import styled, { css } from 'styled-components';
import { breakpointFrom, breakpointUntil } from 'remote-com-shared/style/mediaQueries';
import { desktopBreakpoint } from '@/src/domains/shared/breakpoints';
import IconCheck from '@remote-com/norma/icons/check.svg';

export const FeaturesListItem = styled.li`
  display: inherit;
  align-items: self-start;
  max-width: ${({ $localeHasLongerWords }) => ($localeHasLongerWords ? '230px' : '210px')};
  ${({ theme }) => theme.typography.bodySM}
  line-height: 18px;

  ${desktopBreakpoint(css`
    margin-bottom: 10px;
  `)}
`;

export const FeaturesList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  padding-left: 0;
  margin: 85px 0 0 0;
  font-size: 1rem;
  line-height: 1.7em;
  color: #c1b8ff;

  ${breakpointFrom.lg(css`
    flex-direction: row;
    align-items: center;

    ${FeaturesListItem} + ${FeaturesListItem} {
      margin-left: 18px;
    }
  `)}

  ${breakpointUntil.md(css`
    display: none;
  `)}
`;

export const Check = styled(IconCheck)`
  fill: var(--colors-turquoise);
  min-width: 24px;
  margin-right: 8px;
`;

export const FeaturesListEntry = ({ children, ...props }) => (
  <FeaturesListItem {...props}>
    <Check />
    {children}
  </FeaturesListItem>
);
